import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: '404',
      path: '*',
      component: () => import('page/Home/404'),
    },
    {
      path: '/',
      component: () => import('@/layout/Index'),
      children: [
        //ROTA ABERTA
        {
          path: '',
          name:'home',
          component: () => import('page/Auth/Login/Index'),
          meta: {
            requiresAuth: false,
            drawerHidden:true,
            title: 'Home',
            navigation: []
          },
        },
        {
          path: 'home/:slug',
          name:'home.nav',
          component: () => import('page/Home/Index'),
          meta: {
            requiresAuth: false,
            drawerHidden:true,
            title: 'Home',
            navigation: []
          },
        },
        {
          path: 'nova-conta',
          name:'novaconta',
          component: () => import('page/Home/NovaConta'),
          meta: {
            requiresAuth: false,
            drawerHidden:true,
            title: 'Nova Conta',
            navigation: []
          },
        },
        {
          path: 'guia/:codigo',
          name:'guia',
          component: () => import('page/Home/Guia'),
          meta: {
            requiresAuth: false,
            drawerHidden:true,
            title: 'Home',
            navigation: []
          },
        },
        //ROTA AUTENTICADO
        {
          path: 'app',
          component: () => import('@/layout/Auth'),
          children: [
            {
              path: 'login',
              component: () => import('page/Auth/Login/Index'),
              name:'auth.login',
              meta: {
                requiresAuth: false,
                drawerHidden:true,
                title: 'Login',
                navigation: []
              },
            },
            {
              path: '',
              component: () => import('page/Auth/Home/Index'),
              name:'auth.home',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Início',
                icone:'fa fa-tachometer',
                navigation: [
                  {nome:'Inicio', icone:'fa fa-tachometer', rota:false},
                ]
              },
            },
            //CADASTRO PESSOA
            {
              path: 'cadastro/contato',
              component: () => import('page/Auth/Cadastro/Pessoa/Index'),
              name:'auth.cadastro.pessoa',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Contato',
                icone:'fa fa-book',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Contato', icone:'fa fa-building-o', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/contato/editar/:id',
              component: () => import('page/Auth/Cadastro/Pessoa/Editar'),
              name:'auth.cadastro.pessoa.edit',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Editar Contato',
                icone:'fa fa-pencil-square',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Contato', icone:'fa fa-building-o', rota:'auth.cadastro.pessoa'},
                  {nome:'Editar', icone:'fa fa-pencil-square', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/contato/cadastrar',
              component: () => import('page/Auth/Cadastro/Pessoa/Cadastrar'),
              name:'auth.cadastro.pessoa.register',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Cadastrar Contato',
                icone:'fa fa-plus-circle',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Contato', icone:'fa fa-building-o', rota:'auth.cadastro.pessoa'},
                  {nome:'Cadastrar', icone:'fa fa-plus-circle', rota:false}
                ]
              },
            },
            //VENDEDOR
            {
              path: 'cadastro/vendedor',
              component: () => import('page/Auth/Cadastro/Vendedor/Index'),
              name:'auth.cadastro.vendedor',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Vendedor',
                icone:'fa fa-user-plus',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Vendedor', icone:'fa fa-user-plus', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/vendedor/editar/:id',
              component: () => import('page/Auth/Cadastro/Vendedor/Editar'),
              name:'auth.cadastro.vendedor.edit',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Editar Vendedor',
                icone:'fa fa-pencil-square',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Vendedor', icone:'fa fa-user-plus', rota:'auth.cadastro.vendedor'},
                  {nome:'Editar', icone:'fa fa-pencil-square', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/vendedor/cadastrar',
              component: () => import('page/Auth/Cadastro/Vendedor/Cadastrar'),
              name:'auth.cadastro.vendedor.register',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Cadastrar Vendedor',
                icone:'fa fa-plus-circle',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Vendedor', icone:'fa fa-user-plus', rota:'auth.cadastro.vendedor'},
                  {nome:'Cadastrar', icone:'fa fa-plus-circle', rota:false}
                ]
              },
            },
            //USUARIO
            {
              path: 'cadastro/usuario',
              component: () => import('page/Auth/Cadastro/Usuario/Index'),
              name:'auth.cadastro.usuario',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Usuário',
                icone:'fa fa-users',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Usuário', icone:'fa fa-users', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/usuario/editar/:id',
              component: () => import('page/Auth/Cadastro/Usuario/Editar'),
              name:'auth.cadastro.usuario.edit',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Editar Usuário',
                icone:'fa fa-pencil-square',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Usuário', icone:'fa fa-users', rota:'auth.cadastro.usuario'},
                  {nome:'Editar', icone:'fa fa-pencil-square', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/usuario/cadastrar',
              component: () => import('page/Auth/Cadastro/Usuario/Cadastrar'),
              name:'auth.cadastro.usuario.register',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Cadastrar Usuário',
                icone:'fa fa-plus-circle',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Usuário', icone:'fa fa-users', rota:'auth.cadastro.usuario'},
                  {nome:'Cadastrar', icone:'fa fa-plus-circle', rota:false}
                ]
              },
            },
            //PRODUTO
            {
              path: 'cadastro/produto',
              component: () => import('page/Auth/Cadastro/Produto/Index'),
              name:'auth.cadastro.produto',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Produto',
                icone:'fa fa-product-hunt',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Produto', icone:'fa fa-product-hunt', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/produto/editar/:id',
              component: () => import('page/Auth/Cadastro/Produto/Editar'),
              name:'auth.cadastro.produto.edit',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Editar Produto',
                icone:'fa fa-pencil-square',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Produto', icone:'fa fa-product-hunt', rota:'auth.cadastro.produto'},
                  {nome:'Editar', icone:'fa fa-pencil-square', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/produto/cadastrar',
              component: () => import('page/Auth/Cadastro/Produto/Cadastrar'),
              name:'auth.cadastro.produto.register',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Cadastrar Produto',
                icone:'fa fa-plus-circle',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Produto', icone:'fa fa-product-hunt', rota:'auth.cadastro.produto'},
                  {nome:'Cadastrar', icone:'fa fa-plus-circle', rota:false}
                ]
              },
            },
            //CATEGORIA
            {
              path: 'cadastro/categoria',
              component: () => import('page/Auth/Cadastro/Categoria/Index'),
              name:'auth.cadastro.categoria',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Categoria',
                icone:'fa fa-th-list',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Categoria', icone:'fa fa-th-list', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/categoria/editar/:id',
              component: () => import('page/Auth/Cadastro/Categoria/Editar'),
              name:'auth.cadastro.categoria.edit',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Editar Categoria',
                icone:'fa fa-pencil-square',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Categoria', icone:'fa fa-th-list', rota:'auth.cadastro.categoria'},
                  {nome:'Editar', icone:'fa fa-pencil-square', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/categoria/cadastrar',
              component: () => import('page/Auth/Cadastro/Categoria/Cadastrar'),
              name:'auth.cadastro.categoria.register',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Cadastrar Categoria',
                icone:'fa fa-plus-circle',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Categoria', icone:'fa fa-th-list', rota:'auth.cadastro.categoria'},
                  {nome:'Cadastrar', icone:'fa fa-plus-circle', rota:false}
                ]
              },
            },
            //PAGINA
            {
              path: 'cadastro/pagina',
              component: () => import('page/Auth/Cadastro/Pagina/Index'),
              name:'auth.cadastro.pagina',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Página',
                icone:'fa fa-files-o',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Página', icone:'fa fa-files-o', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/pagina/editar/:id',
              component: () => import('page/Auth/Cadastro/Pagina/Editar'),
              name:'auth.cadastro.pagina.edit',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Editar Página',
                icone:'fa fa-pencil-square',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Página', icone:'fa fa-files-o', rota:'auth.cadastro.pagina'},
                  {nome:'Editar', icone:'fa fa-pencil-square', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/pagina/cadastrar',
              component: () => import('page/Auth/Cadastro/Pagina/Cadastrar'),
              name:'auth.cadastro.pagina.register',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Cadastrar Página',
                icone:'fa fa-plus-circle',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Página', icone:'fa fa-files-o', rota:'auth.cadastro.pagina'},
                  {nome:'Cadastrar', icone:'fa fa-plus-circle', rota:false}
                ]
              },
            },
            //FORNECEDOR
            {
              path: 'cadastro/fornecedor',
              component: () => import('page/Auth/Cadastro/Fornecedor/Index'),
              name:'auth.cadastro.fornecedor',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Fornecedor',
                icone:'fa fa-address-book',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Fornecedor', icone:'fa fa-address-book', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/fornecedor/editar/:id',
              component: () => import('page/Auth/Cadastro/Fornecedor/Editar'),
              name:'auth.cadastro.fornecedor.edit',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Editar Fornecedor',
                icone:'fa fa-pencil-square',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Fornecedor', icone:'fa fa-address-book', rota:'auth.cadastro.fornecedor'},
                  {nome:'Editar', icone:'fa fa-pencil-square', rota:false}
                ]
              },
            },
            {
              path: 'cadastro/fornecedor/cadastrar',
              component: () => import('page/Auth/Cadastro/Fornecedor/Cadastrar'),
              name:'auth.cadastro.fornecedor.register',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Cadastrar Fornecedor',
                icone:'fa fa-plus-circle',
                navigation: [
                  {nome:'Cadastro', icone:'fa fa-book', rota:false},
                  {nome:'Fornecedor', icone:'fa fa-address-book', rota:'auth.cadastro.fornecedor'},
                  {nome:'Cadastrar', icone:'fa fa-plus-circle', rota:false}
                ]
              },
            },
            //MEUS PEDIDOS
            {
              path: 'meus-pedidos',
              component: () => import('page/Auth/MeusPedidos/Index'),
              name:'auth.pedidos',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Meus Pedidos',
                icone:'fa fa-shopping-basket',
                navigation: [
                  {nome:'Meus Pedidos', icone:'fa fa-shopping-basket', rota:false}
                ]
              },
            },
            {
              path: 'meus-pedidos/editar/:id',
              component: () => import('page/Auth/MeusPedidos/Editar'),
              name:'auth.pedidos.edit',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Meus Pedidos',
                icone:'fa fa-shopping-basket',
                navigation: [
                  {nome:'Meus Pedidos', icone:'fa fa-shopping-basket', rota:'auth.pedidos'},
                  {nome:'Editar', icone:'fa fa-pencil-square', rota:false}
                ]
              },
            },
            {
              path: 'meus-pedidos/cadastrar',
              component: () => import('page/Auth/MeusPedidos/Cadastrar'),
              name:'auth.pedidos.register',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Meus Pedidos',
                icone:'fa fa-shopping-basket',
                navigation: [
                  {nome:'Meus Pedidos', icone:'fa fa-shopping-basket', rota:'auth.pedidos'},
                  {nome:'Cadastrar', icone:'fa fa-plus-circle', rota:false}
                ]
              },
            },
            //FINANCEIRO DESPESA
            {
              path: 'financeiro/despesas',
              component: () => import('page/Auth/Financeiro/Despesa/Index'),
              name:'auth.financeiro.despesa',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Despesas',
                icone:'fa fa-upload',
                navigation: [
                  {nome:'Financeiro', icone:'fa fa-usd', rota:false},
                  {nome:'Despesas', icone:'fa fa-upload', rota:false}
                ]
              },
            },
            {
              path: 'financeiro/despesas/editar/:id',
              component: () => import('page/Auth/Financeiro/Despesa/Editar'),
              name:'auth.financeiro.despesa.edit',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Despesas',
                icone:'fa fa-upload',
                navigation: [
                  {nome:'Financeiro', icone:'fa fa-usd', rota:false},
                  {nome:'Despesas', icone:'fa fa-upload', rota:'auth.financeiro.despesa'},
                  {nome:'Editar', icone:'fa fa-pencil-square', rota:false}
                ]
              },
            },
            {
              path: 'financeiro/despesas/cadastrar',
              component: () => import('page/Auth/Financeiro/Despesa/Cadastrar'),
              name:'auth.financeiro.despesa.register',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Despesas',
                icone:'fa fa-upload',
                navigation: [
                  {nome:'Financeiro', icone:'fa fa-usd', rota:false},
                  {nome:'Despesas', icone:'fa fa-upload', rota:'auth.financeiro.despesa'},
                  {nome:'Cadastrar', icone:'fa fa-plus-circle', rota:false}
                ]
              },
            },
            //FINANCEIRO RECEITA
            {
              path: 'financeiro/receitas',
              component: () => import('page/Auth/Financeiro/Receita/Index'),
              name:'auth.financeiro.receita',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Receitas',
                icone:'fa fa-download',
                navigation: [
                  {nome:'Financeiro', icone:'fa fa-usd', rota:false},
                  {nome:'Receitas', icone:'fa fa-download', rota:false}
                ]
              },
            },
            {
              path: 'financeiro/receitas/editar/:id',
              component: () => import('page/Auth/Financeiro/Receita/Editar'),
              name:'auth.financeiro.receita.edit',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Receitas',
                icone:'fa fa-download',
                navigation: [
                  {nome:'Financeiro', icone:'fa fa-usd', rota:false},
                  {nome:'Receitas', icone:'fa fa-download', rota:'auth.financeiro.receita'},
                  {nome:'Editar', icone:'fa fa-pencil-square', rota:false}
                ]
              },
            },
            {
              path: 'financeiro/receitas/cadastrar',
              component: () => import('page/Auth/Financeiro/Receita/Cadastrar'),
              name:'auth.financeiro.despesa.register',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Receitas',
                icone:'fa fa-download',
                navigation: [
                  {nome:'Financeiro', icone:'fa fa-usd', rota:false},
                  {nome:'Receitas', icone:'fa fa-download', rota:'auth.financeiro.receita'},
                  {nome:'Cadastrar', icone:'fa fa-plus-circle', rota:false}
                ]
              },
            },
            //RELATÓRIOS
            {
              path: 'relatorio/produto',
              component: () => import('page/Auth/Relatorios/VendaProduto/Index'),
              name:'auth.relatorio.venda.produto',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Vendas de Produtos',
                icone:'fa fa-usd',
                navigation: [
                  {nome:'Relatorios', icone:'fa fa-bar-chart', rota:false},
                  {nome:'Vendas de Produtos', icone:'fa fa-usd', rota:false}
                ]
              },
            },
            {
              path: 'relatorio/vendedor',
              component: () => import('page/Auth/Relatorios/VendaProduto/Index'),
              name:'auth.relatorio.venda.vendedor',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Vendas por Vendedores',
                icone:'fa fa-usd',
                navigation: [
                  {nome:'Relatorios', icone:'fa fa-bar-chart', rota:false},
                  {nome:'Vendas por Vendedores', icone:'fa fa-usd', rota:false}
                ]
              },
            },
            //INTEGRACAO
            {
              path: 'integracao',
              component: () => import('page/Auth/Integracao/Index'),
              name:'auth.integracao',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Integração',
                icone:'fa fa-globe',
                navigation: [
                  {nome:'Integração', icone:'fa fa-globe', rota:false},
                ]
              },
            },
            //SUPORTE
            {
              path: 'suporte/chamados',
              component: () => import('page/Auth/Suporte/Chamados/Index'),
              name:'auth.suporte.chamados',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Chamados',
                icone:'fa fa-ticket',
                navigation: [
                  {nome:'Suporte', icone:'fa fa-headphones', rota:false},
                  {nome:'Chamados', icone:'fa fa-ticket', rota:false},
                ]
              },
            },
            {
              path: 'suporte/clientes',
              component: () => import('page/Auth/Suporte/Clientes/Index'),
              name:'auth.suporte.clientes',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Clientes',
                icone:'fa fa-users',
                navigation: [
                  {nome:'Suporte', icone:'fa fa-headphones', rota:false},
                  {nome:'Clientes', icone:'fa fa-users', rota:false},
                ]
              },
            },
            //CONFIGURAĆOES
            {
              path: 'configuracao/meu-cadastro',
              component: () => import('page/Auth/Configuracao/MeuCadastro/Index'),
              name:'auth.conf.cadastro',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Alterar Meu Cadastro',
                icone:'fa fa-cog',
                navigation: [
                  {nome:'Configurações', icone:'fa fa-cog', rota:false},
                  {nome:'Alterar Meu Cadastro', icone:'fa fa-id-card-o', rota:false},
                ]
              },
            },
            {
              path: 'configuracao/meu-contrato',
              component: () => import('page/Auth/Configuracao/MeuContrato/Index'),
              name:'auth.conf.contrato',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Alterar Meu Contrato',
                icone:'fa fa-list-alt',
                navigation: [
                  {nome:'Configurações', icone:'fa fa-cog', rota:false},
                  {nome:'Alterar Meu Contrato', icone:'fa fa-list-alt', rota:false},
                ]
              },
            },
            {
              path: 'configuracao/logs/erro',
              component: () => import('page/Auth/Configuracao/Logs/Erro/Index'),
              name:'auth.conf.log.erro',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Log de Erro do Sistema',
                icone:'fa fa-cog',
                navigation: [
                  {nome:'Configurações', icone:'fa fa-cog', rota:false},
                  {nome:'Log de Erro do Sistema', icone:'fa fa-bug', rota:false},
                ]
              },
            },
            {
              path: 'configuracao/logs/acesso',
              component: () => import('page/Auth/Configuracao/Logs/Acesso/Index'),
              name:'auth.conf.log.usuario',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Log de Acesso de Usuários',
                icone:'fa fa-cog',
                navigation: [
                  {nome:'Configurações', icone:'fa fa-cog', rota:false},
                  {nome:'Log de Acesso de Usuários', icone:'fa fa-file-code-o', rota:false},
                ]
              },
            },
            {
              path: 'configuracao/sistema',
              component: () => import('page/Auth/Configuracao/Sistema/Index'),
              name:'auth.conf.sistema',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Sistema',
                icone:'fa fa-globe',
                navigation: [
                  {nome:'Configurações', icone:'fa fa-cog', rota:false},
                  {nome:'Sistema', icone:'fa fa-globe', rota:false},
                ]
              },
            },
            //CONFIGURACÃO GRUPO
            {
              path: 'configuracao/grupo',
              component: () => import('page/Auth/Configuracao/Grupo/Index'),
              name:'auth.conf.grupo',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Grupos de Trabalho',
                icone:'fa fa-share-alt',
                navigation: [
                  {nome:'Configuração', icone:'fa fa-cog', rota:false},
                  {nome:'Grupos de Trabalho', icone:'fa fa-share-alt', rota:false}
                ]
              },
            },
            {
              path: 'configuracao/grupo/:id',
              component: () => import('page/Auth/Configuracao/Grupo/Editar'),
              name:'auth.conf.grupo.edit',
              meta: {
                requiresAuth: true,
                drawerHidden:false,
                title: 'Grupos de Trabalho',
                icone:'fa fa-share-alt',
                navigation: [
                  {nome:'Configuração', icone:'fa fa-cog', rota:false},
                  {nome:'Grupos de Trabalho', icone:'fa fa-share-alt', rota:'auth.conf.grupo'},
                  {nome:'Editar', icone:'fa fa-pencil-square', rota:false}
                ]
              },
            },
          ]
        },

      ]
    },
  ],
  history: true,
  mode: 'history',
})



// WEBPACK FOOTER //
// ./src/router/index.js